export default Object.freeze({
  NotRequired: 0,
  AdminsOnly: 1,
  AllUsers: 2,
});
